import { RouteConfig } from 'react-router-config';
import { Redirect } from 'react-router-dom';
import { AdminCenter } from '../../pages/admin/template';
import { AdminMessage } from '../../pages/admin/message';
import { AdminService } from '../../pages/admin/service';
import { AdminCreateService } from '../../pages/admin/create-service';
import { AdminGauthFail } from '../../pages/admin/gauth-fail';
import { AdminGameManage } from '../../pages/admin/game-manage';
import { OrganizationManage } from '../../pages/admin/organization-manage';
import { AdminUser } from '../../pages/admin/user';
import { AppConfig } from '../../pages/admin/app-config';
import { AdminGameMigration } from '../../pages/admin/game-migration';
import { AdminDownLoadManage } from '../../pages/admin/download';
import { AdminDownloadNews } from '../../pages/admin/download-news';
import { BusinessAccount } from '../../pages/admin/business-account';
import { AdminMailRecord } from '../../pages/admin/mail-record';
import { AdminUpgradeNotification } from '../../pages/admin/upgrade-notification';
import { AdminPriceCalculator } from '../../pages/admin/price-calculator';
import { AdminPermissionManage } from '../../pages/admin/permission';
import { CompanyAuth } from '../../pages/admin/company';
import { AdminBilling } from '../../pages/admin/billing-center';
import { Notice } from '../../pages/admin/notice';
import { CreateUpdateNotice } from '../../pages/admin/notice/create';
import { NoticeList } from '../../pages/admin/notice/list';
import { NoticeDetail, PageMode } from '../../pages/admin/notice/detail';
import { AdminDownLoadRecord } from '../../pages/admin/download-record';

export const ADMIN_ROUTE: RouteConfig[] = [
  {
    path: '/admin',
    component: AdminCenter,
    routes: [
      {
        path: '/admin',
        exact: true,
        render: () => <Redirect to={'/admin/service'} />,
      },
      {
        path: '/admin/service',
        component: AdminService,
      },
      {
        path: '/admin/close-open',
        component: AdminGameManage,
      },
      {
        path: '/admin/message',
        component: AdminMessage,
      },
      {
        path: '/admin/mail-record',
        component: AdminMailRecord,
      },
      {
        path: '/admin/create-service',
        component: AdminCreateService,
      },
      {
        path: '/admin/gauth-fail',
        component: AdminGauthFail,
      },
      {
        path: '/admin/organization-manage',
        component: OrganizationManage,
      },
      {
        path: '/admin/app-config',
        component: AppConfig,
      },
      {
        path: '/admin/user',
        component: AdminUser,
      },
      {
        path: '/admin/admin-account',
        render: () => <BusinessAccount type="approve" />,
      },
      {
        path: '/admin/game-migration',
        component: AdminGameMigration,
      },

      {
        path: '/admin/download',
        component: AdminDownLoadManage,
      },
      {
        path: '/admin/download-record',
        component: AdminDownLoadRecord,
      },
      {
        path: '/admin/download-news',
        component: AdminDownloadNews,
      },
      {
        path: '/admin/business_account',
        render: () => <BusinessAccount type="apply" />,
      },
      {
        path: '/admin/upgrade-notification',
        component: AdminUpgradeNotification,
      },
      {
        path: '/admin/price-calculator',
        component: AdminPriceCalculator,
      },
      {
        path: '/admin/permission',
        component: AdminPermissionManage,
      },
      {
        path: '/admin/support-permission',
        component: AdminPermissionManage,
      },
      {
        path: '/admin/company-auth',
        component: CompanyAuth,
      },
      {
        path: '/admin/fee',
        component: AdminBilling,
      },
      {
        path: '/admin/notice',
        component: Notice,
        routes: [
          {
            path: '/admin/notice/list',
            component: NoticeList,
          },
          {
            path: '/admin/notice/create',
            render: () => <CreateUpdateNotice />,
          },
          {
            path: '/admin/notice/detail/:id',
            render: (props) => (
              <NoticeDetail mode={PageMode.Detail} id={props.match.params.id} />
            ),
          },
          {
            path: '/admin/notice/auth/:id',
            render: (props) => (
              <NoticeDetail mode={PageMode.Auth} id={props.match.params.id} />
            ),
          },
          {
            path: '/admin/notice/update/:id',
            render: (props) => (
              <CreateUpdateNotice id={props.match.params.id} />
            ),
          },
        ],
      },

      {
        path: '*',
        exact: true,
        render: () => <Redirect to="/admin/service" />,
      },
    ],
  },
];
